import { makeContext } from '../../utils'
import { initialProvider } from './initial'

export const { Provider: PrecisionSampleProvider, useContext: usePrecisionSample } = makeContext(
  initialProvider === 'precision',
  'PrecisionSampleContext',
)
